import axios from 'axios';
import { markNaiveTimestampsAsUTC } from './api';

// Local server URL - the store's local offline POS server (runs on the same LAN).
// Defaults to localhost:8002 which is where the local Python service listens.
// Override with REACT_APP_LOCAL_SERVER_URL if a store wraps this in a different runtime.
const LOCAL_SERVER_URL = process.env.REACT_APP_LOCAL_SERVER_URL || 'http://localhost:8002';

const localApi = axios.create({
  baseURL: `${LOCAL_SERVER_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

localApi.interceptors.response.use((response) => {
  if (response?.data && typeof response.data === 'object') {
    response.data = markNaiveTimestampsAsUTC(response.data);
  }
  return response;
});

// ==================== STORE INFO ====================
export const localStoreAPI = {
  getStoreInfo: () => localApi.get('/store-info'),
  getHealth: () => localApi.get('/health'),
};

// ==================== SYNC ====================
export const localSyncAPI = {
  initialize: (data) => localApi.post('/sync/initialize', data),
  getStatus: () => localApi.get('/sync/status'),
  getTerminals: () => localApi.get('/sync/terminals'),
  registerTerminal: (name, type = 'pos') => 
    localApi.post(`/sync/register-terminal?terminal_name=${encodeURIComponent(name)}&terminal_type=${type}`),
  pushToHQ: () => localApi.post('/sync/push'),
  pullFromHQ: () => localApi.post('/sync/pull'),
};

// ==================== CASH REGISTER ====================
export const localCashRegisterAPI = {
  open: (data) => localApi.post('/cash-register/open', data),
  close: (registerId, data) => localApi.post(`/cash-register/close/${registerId}`, data),
  getCurrent: (terminalId) => localApi.get(`/cash-register/current/${terminalId}`),
  getHistory: (terminalId, params) => localApi.get(`/cash-register/history/${terminalId}`, { params }),
  getById: (registerId) => localApi.get(`/cash-register/${registerId}`),
  getDaySummary: (terminalId, date) => localApi.get(`/cash-register/summary/day/${terminalId}`, { params: { date } }),
};

// ==================== POS ====================
export const localPosAPI = {
  searchProducts: (query, limit = 20) => localApi.get('/pos/search-products', { params: { q: query, limit } }),
  getProductByBarcode: (barcode) => localApi.get(`/pos/product/${barcode}`),
  createSale: (data) => localApi.post('/pos/sale', data),
  getSale: (billNumber) => localApi.get(`/pos/sale/${billNumber}`),
  listSales: (params) => localApi.get('/pos/sales', { params }),
  getTodaySummary: (terminalId) => localApi.get(`/pos/today-summary/${terminalId}`),
  holdBill: (data) => localApi.post('/pos/hold-bill', data),
  getHeldBills: (terminalId) => localApi.get(`/pos/held-bills/${terminalId}`),
  getHeldBill: (holdId) => localApi.get(`/pos/held-bill/${holdId}`),
  deleteHeldBill: (holdId) => localApi.delete(`/pos/held-bill/${holdId}`),
};

export default localApi;
